var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "language",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.001,
    viewBox: "0 0 28 28.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M121.262,137h-.338l-.631,3.157h1.6Z",
    transform: "translate(-113.698 -129.47)",
    fill: "#90348a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M381.374,257a8.249,8.249,0,0,0,1.3,2.287A8.335,8.335,0,0,0,384.018,257Z",
    transform: "translate(-360.431 -242.896)",
    fill: "#90348a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M254.467,91h-9.8l2.044,16.4a2.45,2.45,0,0,1-.585,1.8l-3.461,3.956h11.8a2.37,2.37,0,0,0,2.368-2.368V93.42A2.416,2.416,0,0,0,254.467,91Zm0,8.735h-.211a10.015,10.015,0,0,1-1.9,3.457c.58.53,1.2.965,1.816,1.452a.789.789,0,0,1-.987,1.232c-.67-.529-1.3-.971-1.927-1.548-.629.577-1.2,1.019-1.874,1.548a.789.789,0,0,1-.987-1.232c.616-.487,1.184-.922,1.764-1.452a9.962,9.962,0,0,1-1.849-3.457H248.1a.789.789,0,1,1,0-1.579h2.368v-.789a.789.789,0,1,1,1.579,0v.789h2.42a.789.789,0,1,1,0,1.579Z",
    transform: "translate(-228.835 -85.152)",
    fill: "#90348a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M12.847,2.074A2.371,2.371,0,0,0,10.5,0H2.368A2.37,2.37,0,0,0,0,2.368V19.837A2.37,2.37,0,0,0,2.368,22.2H14.815c.23-.263.423-.428.431-.772C15.248,21.347,12.858,2.16,12.847,2.074ZM9.679,15.086a.789.789,0,0,1-.929-.619l-.5-2.523H6.014l-.5,2.523a.789.789,0,1,1-1.548-.31L5.54,6.265a.79.79,0,0,1,.774-.634H7.945a.79.79,0,0,1,.774.634L10.3,14.157A.789.789,0,0,1,9.679,15.086Z",
    fill: "#90348a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M175.261,452l.135,1.083a2.387,2.387,0,0,0,1.365,1.834l2.65-2.917Z",
    transform: "translate(-165.61 -427.157)",
    fill: "#90348a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguage);
export default __webpack_public_path__ + "static/media/icon_language.2ed756d1cad6d85395eb8b834d76317d.svg";
export { ForwardRef as ReactComponent };